// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1maHu","left":"styles_left___e5_r","desktopActions":"styles_desktopActions__3FUby","title":"styles_title__36yZb"};